/**
 * My Procedures is read-only; validation is not used for saves.
 */
export const createMyProceduresValidationSchema = () => null;

export default createMyProceduresValidationSchema;
